<!--직종선택 팝업 -->
<template>
    <modal v-if="isModalShow">
        <template slot="header">
          <h4 class="modal-title">직장 조회</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div class="md-layout">
            <table class="flex-table">
              <tr>
                <th>직종대분류</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" disabled v-model="lCodeCd">
                  </div>
                </td>
                <th>직종소분류</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" disabled v-model="mCodeCd">
                  </div>
                </td>
                <th>직장명</th>
                <td colspan="4">
                  <div class="inline-flex">
                    <input v-focus type="text" v-model="searchText" v-on:keyup.enter="search">
                    <button @click="search">
                      <md-icon>search</md-icon>조회
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <md-card-content>
             <div align="left">총 {{ total }} 건의 검색결과가 있습니다.</div>
             <grid ref="commcodeGrid"
                    :data="gridProps.data"
                    :columns="gridProps.columns"
                    :options="gridProps.options"
                    :theme="gridProps.theme"
                    :rowHeaders="gridProps.rowHeaders"
                    :columnOptions="gridProps.columnOptions"
                    :language="gridProps.lang"
                    @dblclick="onDblClickExecutive"
                    @response="successResponse"
              ></grid>
          </md-card-content>

        </template>
        <template slot="footer">
          <md-button class="md-info md-sm" @click="selectedCompany">
            <md-icon>check</md-icon>입력
          </md-button>
          <md-button v-if="isSave" class="md-info md-sm" @click="saveCompany">
            <md-icon>check</md-icon>등록(직장테이블)
          </md-button>
          <md-button class="md-default md-sm" @click="closed">닫기</md-button>
        </template>
      </modal>
</template>

<script>

import { Modal } from "@/components";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import URL_CONST from "@/kuaa/kuaa-url-const";

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";

export default {
  name: "CompanySearchPopComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    lCodeCd : {
      type: String,
      default: ''
    },
    mCodeCd : {
      type: String,
      default: ''
    },
    searchText : {
      type: String,
      default : ''
    }
  },
  components: {
    Modal,
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
      isModalShow: function(){
          return this.isShow;
      }
  },

  // watch: {
  //   'searchText' (txt) {
  //     if(txt != null && txt != "") this.search();
  //   }
  // },

  data() {
    return {
      total: 0,
      pagination: {
        perPage: 20,
        page: 1,
        total: 0
      },
      isSave: false
    }
  },
  methods: {
    closed(){
        this.$emit('update:isShow', false);
    },
	
    search() {
      let param = {
        level: 'S',
        codeGrpId: 'WORK_CD',
        lCodeCd: this.lCodeCd,
        mCodeCd: this.mCodeCd,
        companyNm: this.searchText,
        perPage: 20
      };
      this.$refs.commcodeGrid.invoke("readData", 1, param);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_COMPANY_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.commcodeGrid;
      this.gridProps['columns'] = [
          {header: '직종대분류', name: 'lCodeNm', width:"100", sortable: true},
          {header: '직종소분류', name: 'mCodeNm', width:"130", sortable: true},
          {header: '코드', name: 'code', width: "60", align:"center", sortable: true},
          {header: '직장명', name: 'codeNm', width:"130", sortable: true},
          {header: '직종대분류코드', name: 'lCodeCd', hidden: true},
          {header: '직종소분류코드', name: 'mCodeCd', hidden: true}
        ];
    },

    successResponse(e) {
      this.isSave = false;
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.total = res.data.pagination.totalCount;
        if(this.total == 0 && this.searchText){
          this.isSave = true;
        }
      }else{
        kuaaFnc.gridErrorCallback(e,"직장 조회");
      }
    },

    onDblClickExecutive(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        this.$emit('returnResult', e.instance.getRow(e.rowKey));
        this.closed();
      }
    },
    
    saveCompany(e) {
      this.isShow = false;
     
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm', {
        html: "직장을 신규 등록 하시겠습니까?"
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          if (e) {
            e.stopPropagation();
            e.preventDefault();
          }
          kuaaApi.sendServer(
              URL_CONST.ADD_COMPANY,
              {
                lCodeCd: this.lCodeCd.trim() == ''? '0025': this.lCodeCd,     // 미분류
                mCodeCd: this.mCodeCd.trim() == ''? '0001': this.mCodeCd,     // 미분류
                companyNm: this.searchText,
                useYn: 'Y'
              },
              "post",
              response => {
                this.closed();
                if (response.data.success) {
                  kuaaFnc.showSwal("직장 등록", '직장 정보가 저장 되었습니다.');
                  this.$emit(
                      'returnResult',
                      {
                        lcodeCd: response.data.data.lCodeCd,
                        mCodeCd: response.data.data.mCodeCd,
                        code: response.data.data.companyId,
                        codeNm: response.data.data.companyNm
                      }
                  );
                  return false;
                } else {
                  kuaaFnc.showSwal("직장 등록", response.data.resultMessage);
                  return false;
                }
              }
          );
        }
      });
    },

    selectedCompany(e){
      let data = {
        lCodeCd: '',
        lCodeNm: '',
        mCodeCd: '',
        mCodeNm: '',
        code: '',
        codeNm: this.searchText
      };
      this.$emit('returnResult', data);
      this.closed();
    }
  }
}
</script>

<style lang="css" scoped>

</style>